import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableContainer,
  TableBody,
  Paper,
} from "@mui/material";
import moment from "moment";
import { Stack } from "@mui/system";
import HTMLReactParser from "html-react-parser";
import hexToRgb from "assets/theme/functions/hexToRgb";

function ViewAuditLogDetails({ logData }) {
  const viewData = logData?.dataDifference[0]?.fields ?? [];
  const viewHeading = logData?.logDetails;

  const renderSubTitle = (
    <Stack spacing={1}>
      <Stack
        spacing={5}
        direction="row"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MDBox component="span">Action:</MDBox>
          <MDBox component="span" sx={{ fontWeight: "bold" }}>
            {viewHeading?.action ?? "-"}
          </MDBox>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MDBox component="span">Module:</MDBox>
          <MDBox component="span" sx={{ fontWeight: "bold" }}>
            {viewHeading?.module === "Report Metadata" ? "Reports" : viewHeading?.module ?? "-"}
          </MDBox>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MDBox component="span">Record ID:</MDBox>
          <MDBox component="span" sx={{ fontWeight: "bold" }}>
            {viewHeading?.record_id ?? "-"}
          </MDBox>
        </Stack>

        {viewHeading?.case?.family_id && (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <MDBox component="span">Case ID:</MDBox>
            <MDBox component="span" sx={{ fontWeight: "bold" }}>
              {viewHeading?.case?.family_id ?? "-"}
            </MDBox>
          </Stack>
        )}

        {viewHeading?.case?.identification_number && (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <MDBox component="span">Identification Number:</MDBox>
            <MDBox component="span" sx={{ fontWeight: "bold" }}>
              {viewHeading?.case?.identification_number ?? "-"}
            </MDBox>
          </Stack>
        )}

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MDBox component="span">User:</MDBox>
          <MDBox component="span" sx={{ fontWeight: "bold" }}>
            {viewHeading?.user?.first_name} {viewHeading?.user.last_name}{" "}
          </MDBox>
        </Stack>

        {viewHeading?.ip_address && (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <MDBox component="span">IP Address:</MDBox>
            <MDBox component="span" sx={{ fontWeight: "bold" }}>
              {viewHeading?.ip_address ?? "-"}
            </MDBox>
          </Stack>
        )}

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MDBox component="span">Created Date:</MDBox>
          <MDBox component="span" sx={{ fontWeight: "bold" }}>
            {viewHeading?.created_at
              ? moment(viewHeading?.created_at).format("MM-DD-YYYY HH:mm:ss")
              : "-"}
          </MDBox>
        </Stack>
      </Stack>
    </Stack>
  );

  const renderChangesTable = (
    <TableContainer
      component={Paper}
      sx={{
        mt: 2,
        maxHeight: "70vh",
        overflow: "auto",
        boxShadow: "none",
        border: "1px solid #e0e0e0",
      }}
    >
      {!Array.isArray(viewData) || viewData.length === 0 ? (
        <MDBox sx={{ height: 300 }}>
          {/* <LoadingScreen /> */}
          {/* Loading... */}
        </MDBox>
      ) : (
        <Table aria-label="comparison table" stickyHeader>
          <TableHead
            sx={{
              display: "table-header-group",
            }}
          >
            <TableRow>
              <TableCell
              // sx={(theme) => ({
              //   backgroundColor: theme.palette.grey[200],
              //   "&.MuiTableCell-stickyHeader": {
              //     backgroundColor: theme.palette.grey[200],
              //   },
              // })}
              >
                <MDTypography variant="h6" fontWeight="bold">
                  Field Name
                </MDTypography>
              </TableCell>
              <TableCell
              // sx={(theme) => ({
              //   backgroundColor: theme.palette.grey[200],
              //   "&.MuiTableCell-stickyHeader": {
              //     backgroundColor: theme.palette.grey[200],
              //   },
              // })}
              >
                <MDTypography variant="h6" fontWeight="bold">
                  Old Value
                </MDTypography>
              </TableCell>
              <TableCell
              // sx={(theme) => ({
              //   backgroundColor: theme.palette.grey[200],
              //   "&.MuiTableCell-stickyHeader": {
              //     backgroundColor: theme.palette.grey[200],
              //   },
              // })}
              >
                <MDTypography variant="h6" fontWeight="bold">
                  New Value
                </MDTypography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {viewData?.map((row, index) => (
              <TableRow
                key={index}
                sx={(theme) => ({
                  "& td": {
                    borderBottom: `1px solid ${theme.palette.grey[300]}`,
                  },
                })}
              >
                <TableCell>
                  <MDTypography variant="button" fontWeight="medium">
                    {row.field}
                  </MDTypography>
                </TableCell>
                <TableCell
                  sx={(theme) => ({
                    backgroundColor: row.is_changed
                      ? `rgba(${hexToRgb(theme.palette.error.main)}, 0.1)`
                      : "inherit",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    maxWidth: "200px",
                  })}
                >
                  <MDTypography variant="body2">
                    {HTMLReactParser(row.old?.toString() ?? "")}
                  </MDTypography>
                </TableCell>
                <TableCell
                  sx={(theme) => ({
                    backgroundColor: row.is_changed
                      ? `rgba(${hexToRgb(theme.palette.success.main)}, 0.1)`
                      : "inherit",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    maxWidth: "200px",
                  })}
                >
                  <MDTypography variant="body2">
                    {HTMLReactParser(row.new?.toString() ?? "")}
                  </MDTypography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );

  return (
    <>
      {/* Header Details */}
      {renderSubTitle}

      {/* Changes Table */}
      {renderChangesTable}
    </>
  );
}

export default ViewAuditLogDetails;
